module.exports = __webpack_public_path__ + "img/kopiarka.5339d919.gif";